import { render, staticRenderFns } from "./BettingHistory.vue?vue&type=template&id=c4560a1c&scoped=true&"
import script from "./BettingHistory.vue?vue&type=script&lang=js&"
export * from "./BettingHistory.vue?vue&type=script&lang=js&"
import style0 from "./BettingHistory.vue?vue&type=style&index=0&id=c4560a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4560a1c",
  null
  
)

export default component.exports